/* eslint-disable jsx-a11y/media-has-caption */
import useChatPickupAsync from '@src/hooks/useChatPickupAsync';
import usePreventMultipleClicks from '@src/hooks/usePreventMultipleClicks';
import { useCallMedia } from '@src/logic/call';
import { decrementTotalCallsOnHold } from '@src/reducers/chats';
import { getUserId } from '@src/selectors/user';
import { Call, CallStatus } from '@src/types/calls';
import { ChatSideType } from '@src/types/chats';
import { useDispatch, useSelector } from 'react-redux';
import IncomingCallMissedView from './IncomingCallMissedView';
import IncomingCallView from './IncomingCallView';

const IncomingCall: React.FC<{ call: Call; chatSide: ChatSideType }> = ({
  call,
  chatSide,
}) => {
  const dispatch = useDispatch();
  const callMedia = useCallMedia(call);
  const agentId = useSelector(getUserId);
  const pickupChatAsync = useChatPickupAsync();

  // The pickup / counter update runs inside startCall, after it claimed the answer, so
  // a click it refuses (the other Answer button won) does neither.
  const onStartCall = () =>
    callMedia.startCall(async () => {
      if ([ChatSideType.REQUEST, ChatSideType.BOT].includes(chatSide))
        await pickupChatAsync(call.chatId, agentId);
      else dispatch(decrementTotalCallsOnHold());
    });

  const safeStartCall = usePreventMultipleClicks(onStartCall, {
    blockTimeMs: 2000,
  });

  const onEndCall = () => callMedia.endCall();

  const safeEndCall = usePreventMultipleClicks(onEndCall, {
    blockTimeMs: 2000,
  });

  if (call.status === CallStatus.MISSED) return <IncomingCallMissedView />;

  return (
    <IncomingCallView
      isLoadingEndCall={callMedia.ending}
      isLoadingStartCall={callMedia.starting}
      onStartCall={safeStartCall}
      onEndCall={safeEndCall}
    />
  );
};

export default IncomingCall;
